import { baseAPI } from '~shared/api/base-api';

export const exportCostumeSizingCSV = async (recitalId: string): Promise<Blob> => {
  const response = await baseAPI.get(
    `/recitals/${recitalId}/sizing/export/csv`,
    {
      responseType: 'blob',
    }
  );
  return response.data;
};

export const downloadCostumeSizingCSV = async (recitalId: string): Promise<void> => {
  const blob = await exportCostumeSizingCSV(recitalId);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `recital-${recitalId}-costume-sizing.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const exportCostumeSizingCSVAPI = async (recitalId: string) => {
  await downloadCostumeSizingCSV(recitalId);
  return true;
};

export const useExportCostumeSizingCSV = () => {
  return {
    exportCSV: exportCostumeSizingCSVAPI,
  };
};
